<template>
    <div>
        <h4 class="text-center thank-you-heading">
            {{ heading }}
        </h4>
        <p v-if="data.token"
                class="text-center paragraph"
                style="padding: 0px icon-customer-profil30px"
        >
            Almost done! Please enter the 6 digit password that has been sent to
            your email
        </p>
        <p v-else
           class="text-center paragraph"
           style="padding: 0px icon-customer-profil30px"
        >
            Almost done! Please enter the 6 digit password from your authenticator APP
        </p>

        <b-form-group id="input-group-1" label="otp-code" label-for="otpcode">
            <b-form-input
                    id="otpcode"
                    v-model="otpCode"
                    v-validate="{ required: true, min:6 ,max: 6, regex: /^([0-9]*)$/ }"
                    type="text"
                    required
                    name="OTP code"
                    autocomplete="no"
                    placeholder="Enter OTP code"
            ></b-form-input>
            <span v-if="isError" class="text-center color-red">{{
                isError
            }}</span>
        </b-form-group>
        <div class="row">
            <div class="col-12">
                <div class="row justify-content-center">
                    <!--<popup-button v-if="data.token"-->
                            <!--btn-type="button"-->
                            <!--btn-variant="primary"-->
                            <!--:btn-label="-->
                            <!--countDown > 0 ? 'Submit OTP' : 'Resend Code'-->
                        <!--"-->
                            <!--:class="loading ? 'disabled' : ''"-->
                            <!--:disabled="loading"-->
                            <!--@onClickButton="initRecaptcha"-->
                    <!--&gt;-->
                    <!--</popup-button>-->
                    <popup-button
                                  btn-type="button"
                                  btn-variant="primary"
                                  btn-label="Submit OTP"
                                  :class="loading ? 'disabled' : ''"
                                  :disabled="loading"
                                  @onClickButton="initRecaptcha"
                    >
                    </popup-button>
                </div>
            </div>
        </div>
        <p
                v-if="countDown > 0 && data.token"
                class="text-center paragraph fs-13 my-3"
                style="padding: 0px icon-customer-profil30px"
        >
            Code expires in {{ countDown }} seconds
        </p>

    </div>
</template>
<script>
    import axios from 'axios'

    import Recaptcha from '@/components/registration/Recaptcha.vue'
    import request from '@/utils/request'
    import PopupButton from '@/components/registration/PopupButton.vue'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            Recaptcha,
            PopupButton,
        },

        props: {
            data: { type: String },
            heading:{type:String}
        },
        data() {
            return {
                otpCode: '',
                resendDisable: true,
                countDown: 60,
                responseData: '',
                isError: '',
                recaptchaResponse: '',
                isLogin:false
            }
        },

        /*
      |--------------------------------------------------------------------------
      | Component > computed
      |--------------------------------------------------------------------------
      */
        computed: {
            ...mapGetters(['loading']),
        }, // End of Component > methods

        /*
      |--------------------------------------------------------------------------
      | Component > mounted
      |--------------------------------------------------------------------------
      */

        mounted() {
            if(this.data.token)
            {
                this.countDownTimer()
            }
            // console.log('PropsData: ' + JSON.stringify(this.data))
        },
        methods: {
            async onVerify(response) {
                if (response) {
                    this.recaptchaResponse = response
                    this.$refs.modalRecaptcha.hide()
                    this.submitOTP()
                }
            },

            async initRecaptcha() {
                if (this.countDown > 0) {
                    const result = await this.$validator.validateAll()

                    if (result) {
                        this.submitOTP()

                        // this.$refs.modalRecaptcha.show()
                    }
                    const digits=this.otpCode.length
                    if(digits>6){
                        this.isError="OTP should not be greater than 6 digits"
                        this.$store.commit('setError', this.isError)
                    }
                    if(digits<6)
                    { this.isError="OTP should not be less than 6 digits"
                        this.$store.commit('setError', this.isError)
                    }
                } else {
                    this.submitResend()
                }
            },

            async submitOTP() {
                this.$store.commit('setLoading', true)
                const result = await this.$validator.validateAll()

                if (result) {
                    const formData = {
                        otp: this.otpCode,
                    }
                    var mergedData = {
                        ...this.data,
                        ...formData
                    };
                    let encryptedForm = this.$encrypt(mergedData)

                    let resp =  await axios.post(`${process.env.VUE_APP_API_URL}users/login`, {
                        data:encryptedForm,
                    })
                        .then(function (response) {
                            return response
                        })
                        .catch(function (error) {
                            if (error.response) {
                                return {error : error.response.data.message};
                            } else if (error.request) {
                                // return {error :'No response received from server'}
                                return {error :'Your IP has been blocked, please contact Admin'}
                            } else {
                                // Something happened in setting up the request that triggered an Error
                                return {error :error.message};
                            }
                        });

                    if (resp) {
                        this.isLogin=true
                        this.$emit('verificationStatus', resp)
                    } else {
                    }
                } else {
                    // this.$store.commit('setError', this.errors.all()[0])


                }

                this.$store.commit('setLoading', false)
            },

            countDownTimer() {
                if (this.countDown > 0) {
                    setTimeout(() => {
                        this.countDown -= 1
                        this.countDownTimer()
                    }, 1000)
                } else {
                    if(!this.isLogin)
                    {
                        this.resendDisable = false
                        this.$store.commit('setError', "OTP has been expired, please login again")
                        this.$emit('reSendOTP')
                    }
                    // this.isError =
                    //     'Your OTP code is expired, please click resend OTP'
                }
            },
            submitResend() {
                this.$store.commit('setError', "OTP has been expired, please login again")
                this.$emit('reSendOTP')
                // this.initCountDown()
            },
            initCountDown() {
                this.countDown = 60
                this.countDownTimer()
                this.isError = null
            },
        },
    }
</script>
<style scoped>
    p {
        margin: 0;
        font-size: 16px;
        padding: 0px 20px;
    }
    .icon-tick-with-circle {
        color: green;
        font-size: 30px;
        cursor: pointer;
    }
</style>
